import { render, staticRenderFns } from "./cadastrar_agendamento_especialidade.vue?vue&type=template&id=aba262c6&scoped=true"
import script from "./cadastrar_agendamento_especialidade.vue?vue&type=script&lang=js"
export * from "./cadastrar_agendamento_especialidade.vue?vue&type=script&lang=js"
import style0 from "./cadastrar_agendamento_especialidade.vue?vue&type=style&index=0&id=aba262c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba262c6",
  null
  
)

export default component.exports